import { __decorate } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var BuybackService;
(function (BuybackService) {
    BuybackService.SYMBOL = Symbol.for('BuybackService');
})(BuybackService || (BuybackService = {}));
export default (container) => {
    let BuybackServiceImpl = class BuybackServiceImpl {
        constructor() {
            Object.defineProperty(this, "CORS_PROXY", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://sparkling-dew-b13c.visualkhh.workers.dev/?url='
            });
            Object.defineProperty(this, "API_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://mkind.krx.co.kr/api/trstk/applied'
            });
            Object.defineProperty(this, "TRADED_API_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://mkind.krx.co.kr/api/trstk/traded'
            });
            Object.defineProperty(this, "DECLARED_API_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://mkind.krx.co.kr/api/trstk/declared'
            });
            Object.defineProperty(this, "SEARCH_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://kind.krx.co.kr/disclosure/searchtotalinfo.do'
            });
            Object.defineProperty(this, "VIEWER_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://kind.krx.co.kr/common/disclsviewer.do'
            });
            Object.defineProperty(this, "TOTALINFO_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://kind.krx.co.kr/corpdetail/totalinfo.do'
            });
            Object.defineProperty(this, "CORP_LIST_BASE", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://kind.krx.co.kr/common/corpList.do'
            });
            Object.defineProperty(this, "companies", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: [
                    { code: '000660', name: 'SK하이닉스', color: '#ed1c24' },
                    { code: '005930', name: '삼성전자', color: '#1428a0' },
                ]
            });
        }
        getCompanies() {
            return this.companies;
        }
        buildUrl(base, code, fromDate, toDate, pageNo = 1) {
            const now = new Date();
            fromDate ?? (fromDate = `${now.getFullYear()}-01-01`);
            toDate ?? (toDate = `${now.getFullYear()}-12-31`);
            const tParam = pageNo === 1 ? `&_t=${Date.now()}` : '';
            const apiUrl = `${base}?marketType=&repIsuSrtCd=${code}&fromDate=${fromDate}&toDate=${toDate}&pageNo=${pageNo}${tParam}`;
            return `${this.CORS_PROXY}${encodeURIComponent(apiUrl)}${tParam}`;
        }
        async getAppliedList(code) {
            try {
                const response = await fetch(this.buildUrl(this.API_BASE, code));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                const allItems = json.dataList || [];
                return allItems
                    .map((item) => ({
                    companyName: item.com_abbrv,
                    companyCode: item.rep_isu_srt_cd,
                    applDate: item.trstk_appl_dd || '',
                    tradeDate: item.trd_dd || '',
                    appliedQty: Number(item.trstk_appl_qty) || 0,
                    typeCode: item.trstk_acqstdisp_tp_cd || '',
                }))
                    .sort((a, b) => b.applDate.localeCompare(a.applDate));
            }
            catch (e) {
                console.error('[BuybackService] Applied list fetch failed:', e);
                return [];
            }
        }
        async getTradedList(code) {
            try {
                const response = await fetch(this.buildUrl(this.TRADED_API_BASE, code));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                const allItems = json.dataList || [];
                return allItems
                    .map((item) => ({
                    companyName: item.com_abbrv || '',
                    companyCode: item.rep_isu_srt_cd || code,
                    tradeDate: item.trd_dd || item.trstk_trd_dd || item.appl_dd || '',
                    appliedQty: Number(item.trstk_appl_qty ??
                        item.appl_qty ??
                        0) || 0,
                    tradedQty: Number(item.trstk_trd_qty ??
                        item.trd_qty ??
                        item.acqst_qty ??
                        item.trstk_acqst_qty ??
                        item.qty ??
                        0) || 0,
                    typeCode: item.trstk_acqstdisp_tp_cd || item.trstk_tp_cd || '',
                }))
                    .sort((a, b) => b.tradeDate.localeCompare(a.tradeDate));
            }
            catch (e) {
                console.error('[BuybackService] Traded fetch failed:', e);
                return [];
            }
        }
        async getDeclaredList(code) {
            try {
                const response = await fetch(this.buildUrl(this.DECLARED_API_BASE, code));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                const allItems = json.dataList || [];
                return allItems.map((item) => ({
                    companyName: item.com_abbrv,
                    companyCode: item.rep_isu_srt_cd,
                    declDate: item.trstk_decl_dd || '',
                    startDate: item.trstk_decl_strt_dd || '',
                    endDate: item.trstk_decl_end_dd || '',
                    declQty: Number(item.trstk_decl_qty) || 0,
                    typeCode: item.trstk_tp_cd || '',
                }));
            }
            catch (e) {
                console.error('[BuybackService] Declared fetch failed:', e);
                return [];
            }
        }
        async getCompanyCodes(code, name = '') {
            try {
                const params = [
                    'method=searchCorpList',
                    'forward=corpList',
                    'pageIndex=1',
                    'beginIndex=',
                    'currentPageSize=10',
                    'delistFlag=Y',
                    'sub=',
                    'kwd=',
                    'searchCorp=',
                    `corpName=${encodeURIComponent(name)}`,
                    'marketType=stockMkt',
                ].join('&');
                const response = await fetch(this.buildProxyUrl(`${this.CORP_LIST_BASE}?${params}`));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const html = await response.text();
                const isurCd = code.slice(0, 5);
                const pattern = new RegExp(`setCorpInfo\\('${isurCd}','(\\d+)','([^']+)'`);
                const match = html.match(pattern);
                return match ? { kisComCd: match[1], repIsuCd: match[2] } : null;
            }
            catch (e) {
                console.warn('[BuybackService] Company codes lookup failed:', e);
                return null;
            }
        }
        buildProxyUrl(url) {
            const separator = url.includes('?') ? '&' : '?';
            const targetUrl = `${url}${separator}_t=${Date.now()}`;
            return `${this.CORS_PROXY}${encodeURIComponent(targetUrl)}&_t=${Date.now()}`;
        }
        async getDisclosureList() {
            try {
                const now = new Date();
                const fromDate = `${now.getFullYear()}-01-01`;
                const toDate = `${now.getFullYear()}-12-31`;
                const kwd = encodeURIComponent('자기주식매매 신청내역(유가증권시장)');
                const params = [
                    'method=searchTotalInfoSub',
                    'forward=searchtotalinfo_detail',
                    'searchCodeType=char',
                    `searchCorpName=${kwd}`,
                    'repIsuSrtCd=',
                    'isurCd=',
                    'fdName=all_mktact_idx',
                    'pageIndex=1',
                    'currentPageSize=15',
                    'scn=mktact',
                    'repIsuCd=',
                    'srchFd=2',
                    `kwd=${kwd}`,
                    `fromData=${fromDate}`,
                    `toData=${toDate}`,
                ].join('&');
                const url = `${this.SEARCH_BASE}?${params}`;
                const response = await fetch(this.buildProxyUrl(url));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const html = await response.text();
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const items = [];
                doc.querySelectorAll('.subject a[onclick*="openDisclsViewer"]').forEach(a => {
                    const onclick = a.getAttribute('onclick') || '';
                    const match = onclick.match(/openDisclsViewer\('(\d+)', '(\d+)'/);
                    if (!match)
                        return;
                    const acptNo = match[1];
                    const docNo = match[2];
                    const dateEl = a.closest('dt')?.querySelector('.date');
                    const date = dateEl ? dateEl.textContent?.trim() || '' : '';
                    const rawTitle = a.getAttribute('title') || '';
                    const title = rawTitle.replace(/<[^>]+>/g, '');
                    items.push({
                        date,
                        title,
                        acptNo,
                        docNo,
                        viewerUrl: `${this.VIEWER_BASE}?method=search&acptno=${acptNo}&docno=${docNo}&viewerhost=&viewerport=`,
                    });
                });
                return items;
            }
            catch (e) {
                console.error('[BuybackService] Disclosure search failed:', e);
                return [];
            }
        }
        async getCompanyInfo(code) {
            const isurCd = code.slice(0, 5);
            const matchedCompany = this.companies.find(c => c.code === code);
            const companyName = matchedCompany ? matchedCompany.name : '';
            const codes = await this.getCompanyCodes(code, companyName);
            let url = `${this.TOTALINFO_BASE}?method=searchTotalInfo&isurCd=${isurCd}`;
            if (codes) {
                url += `&kisComCd=${codes.kisComCd}&repIsuCd=${encodeURIComponent(codes.repIsuCd)}`;
            }
            const response = await fetch(this.buildProxyUrl(url));
            if (!response.ok)
                throw new Error(`HTTP error! status: ${response.status}`);
            const html = await response.text();
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const norm = (s) => s.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
            const parsePairs = (root) => {
                const pairs = new Map();
                root.querySelectorAll('table.detail:not(.tdr) tr').forEach(tr => {
                    const ths = tr.querySelectorAll('th');
                    const tds = tr.querySelectorAll('td');
                    for (let i = 0; i < ths.length && i < tds.length; i++) {
                        const key = norm(ths[i].textContent || '');
                        const value = norm(tds[i].textContent || '');
                        if (key)
                            pairs.set(key, value);
                    }
                });
                return pairs;
            };
            const pairs = parsePairs(doc);
            const get = (k) => pairs.get(k) || '-';
            const pick = (...keys) => {
                for (const k of keys) {
                    const v = pairs.get(k);
                    if (v)
                        return v;
                }
                return '-';
            };
            const pricePairs = new Map();
            doc.querySelectorAll('table.tdr tr').forEach(tr => {
                const ths = tr.querySelectorAll('th');
                const tds = tr.querySelectorAll('td');
                for (let i = 0; i < ths.length && i < tds.length; i++) {
                    const key = norm(ths[i].textContent || '');
                    const value = norm(tds[i].textContent || '');
                    if (key)
                        pricePairs.set(key, value);
                }
            });
            const pget = (k) => pricePairs.get(k) || '-';
            const outlookH2 = [...doc.querySelectorAll('h2')].find(h => h.textContent?.includes('현황 및 전망'));
            const outlook = outlookH2?.nextElementSibling?.textContent?.replace(/\u00a0/g, ' ').trim()
                || outlookH2?.closest('.section')?.textContent?.replace(/\u00a0/g, ' ').trim()
                || '-';
            return {
                korName: get('한글명'),
                engName: get('영문명'),
                stdCode: get('표준코드'),
                stockCode: get('종목코드'),
                founded: get('설립일'),
                market: get('시장구분'),
                ceo: get('대표이사'),
                listed: get('상장일'),
                capital: pick('자본금(천원)', '자본금 (천원)', '자본금'),
                employees: get('종업원수'),
                closeMonth: get('결산월'),
                phone: get('전화번호'),
                industry: get('업종'),
                products: get('주요제품'),
                address: get('주소'),
                homepage: get('홈페이지'),
                price: {
                    current: pget('현재가'),
                    ask: pget('매도호가'),
                    bid: pget('매수호가'),
                    change: pget('전일대비'),
                    changePct: pget('등락율(%)'),
                    prevClose: pget('전일가'),
                    open: pget('시가'),
                    high: pget('고가'),
                    low: pget('저가'),
                    volume: pget('거래량'),
                    amount: pget('거래대금'),
                    par: pget('액면가'),
                    upper: pget('상한가'),
                    lower: pget('하한가'),
                    prevUpper: pget('전일상한'),
                    prevLower: pget('전일하한'),
                },
                outlook,
            };
        }
        async getStockStatus(company) {
            try {
                const url = `https://mkind.krx.co.kr/api/corp-detail/stockstatus?repIsuSrtCd=${company.code}&isurCd=&corpName=${encodeURIComponent(company.name)}`;
                const response = await fetch(this.buildProxyUrl(url));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                return json;
            }
            catch (e) {
                console.error('[BuybackService] Stock status fetch failed:', e);
                return null;
            }
        }
        async getChart(code, months = 6) {
            try {
                const count = Math.min(300, Math.max(30, months * 21));
                const url = `https://fchart.stock.naver.com/sise.nhn?symbol=${code}&timeframe=day&count=${count}&requestType=0`;
                const response = await fetch(this.buildProxyUrl(url));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const text = await response.text();
                const items = [...text.matchAll(/<item data="(\d{8})\|([\d.]+)\|([\d.]+)\|([\d.]+)\|([\d.]+)\|(\d+)"\s*\/?>/g)];
                return items.map(m => ({
                    date: `${m[1].slice(0, 4)}-${m[1].slice(4, 6)}-${m[1].slice(6, 8)}`,
                    open: Number(m[2]) || 0,
                    high: Number(m[3]) || 0,
                    low: Number(m[4]) || 0,
                    close: Number(m[5]) || 0,
                    volume: Number(m[6]) || 0,
                    gongsi: false,
                }));
            }
            catch (e) {
                console.error('[BuybackService] Chart fetch failed:', e);
                return [];
            }
        }
        async searchCompany(keyword) {
            try {
                const url = `https://mkind.krx.co.kr/api/common/findcorp-ac?search_keyword=${encodeURIComponent(keyword)}`;
                const response = await fetch(this.buildProxyUrl(url));
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                const list = json.dataList || [];
                // findcorp-ac는 이름 검색 시 isu_cd=코드/corp_name=이름, 코드 검색 시 반대로 뒤집혀 반환될 수 있음 → 정규화
                return list.map((item) => {
                    const a = String(item.isu_cd || item.code || '');
                    const b = String(item.corp_name || item.name || '');
                    const aIsCode = /^\d{6}$/.test(a);
                    const bIsCode = /^\d{6}$/.test(b);
                    return { code: aIsCode ? a : (bIsCode ? b : a), name: aIsCode ? b : a };
                });
            }
            catch (e) {
                console.error('[BuybackService] Company search failed:', e);
                return [];
            }
        }
        getDeadline(item) {
            const d = item.applDate;
            const dateStr = `${d.slice(0, 4)}-${d.slice(4, 6)}-${d.slice(6, 8)}T18:00:00+09:00`;
            return new Date(dateStr);
        }
    };
    BuybackServiceImpl = __decorate([
        Sim({ symbol: BuybackService.SYMBOL, container: container })
    ], BuybackServiceImpl);
    return BuybackServiceImpl;
};
